import axios from "axios";
import Cookies from "universal-cookie";
import { backendUrl } from "../utils/url";
import { buildSelfContainedHtml } from "../Components/article-editor";

const cookies = new Cookies();

const api = axios.create({
  baseURL: backendUrl,
  timeout: 5000,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${cookies.get("jwt-auth")}`,
  },
});

const buildHeaders = () => {
  const headers = {};
  const token =
    typeof localStorage !== "undefined" ? localStorage.getItem("token") : null;
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
};

export const deleteQuestion = async (id) => {
  try {
    const res = await api.delete("/question/" + id);
    return res;
  } catch (err) {
    return err.response;
  }
};

export const checkQuestion = async (id) => {
  try {
    const res = await api.put("/question/check/" + id);
    return res;
  } catch (err) {
    return err.response;
  }
};

export const updateQuestion = async (formData, id) => {
  try {
    const token = cookies.get("jwt-auth");
    const res = await axios.put(backendUrl + "/question/" + id, formData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return res;
  } catch (err) {
    return err.response;
  }
};

export const getQuestion = async () => {
  try {
    const res = await api.get("/question/all");
    return res;
  } catch (err) {
    return err.response;
  }
};

export const getPaginatedQuestions = async (params) => {
  try {
    const queryParams = {};
    if (params.search) queryParams.search = params.search;
    if (params.lesson) queryParams.lesson = params.lesson;
    if (params.grade) queryParams.grade = params.grade;
    if (params.book) queryParams.book = params.book;
    queryParams.page = params.page || 1;
    queryParams.limit = params.limit || 10;

    const res = await api.get("/question/paginated", { params: queryParams });
    return res.data;
  } catch (err) {
    return {
      lessons: [],
      total: 0,
      page: 1,
      totalPages: 1,
      message: err.response?.data?.message || "خطای شبکه",
      success: false,
    };
  }
};

export const addQuestion = async (formData) => {
  try {
    const token = cookies.get("jwt-auth");
    const response = await axios.post(
      backendUrl + "/question/create",
      formData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response;
  } catch (err) {
    return err.response;
  }
};

export const addImage = async (formData) => {
  try {
    const token = cookies.get("jwt-auth");
    const response = await axios.post(backendUrl + "/upload/image", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (err) {
    return err.response;
  }
};

export const uploadQuestionsImage = async (file) => {
  try {
    const formData = new FormData();
    formData.append("image", file);
    const token = cookies.get("jwt-auth");
    const res = await axios.post(
      backendUrl + "/upload/questionsImage",
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return res;
  } catch (err) {
    if (err.response) {
      return err.response;
    } else if (err.request) {
      console.error("📡 درخواست انجام شد اما پاسخی دریافت نشد");
    } else {
      console.error("⚙️ خطا در تنظیم درخواست:", err.message);
    }
    return Promise.reject(err);
  }
};

export const createQuestion = async (htmlContent) => {
  const selfContained = await buildSelfContainedHtml(htmlContent);
  const response = await fetch(`${backendUrl}/question/create-test`, {
    method: "POST",
    headers: {
      ...buildHeaders(),
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ content: selfContained }),
  });
  if (response.status !== 201) {
    throw new Error(`ثبت سوال ناموفق بود (کد ${response.status})`);
  }

  return response.json();
};
